import React, { useContext } from 'react';
import {MoneyField} from "buenLib/components/MoneyField";
import {images} from "assets/img/dashboard/buy-and-sell/buy-and-sell";
import {ReactSVG} from "react-svg";
import 'assets/sass/dashboard/buy-and-sell/CurrencyCard.scss';
import { AppContext } from 'app/state/AppContext';

export function CurrencyCard({currency, balance, displayAsPlaceholder = false}) {
    const { getCurrencyInstance } = useContext(AppContext);

    return (
        <div className="currency-card">
            {
                displayAsPlaceholder ? (
                    <div className="content">Cargando&hellip;</div>
                ) : (
                    <>
                        <figure className="icon">
                            <ReactSVG src={images[`${currency}Ball`]}/>
                        </figure>
                        <div className="content">
                            <p className={`currency-name ${currency}`}>{getCurrencyInstance(currency).asVerbose(true, true)}</p>
                            <p className="balance">Saldo: {balance ? "" : "Cargando..."}<MoneyField currency={currency}
                                                                                                    value={balance}/></p>
                        </div>
                    </>
                )
            }

        </div>
    );
}
